import { render, staticRenderFns } from "./PlgBrand.vue?vue&type=template&id=0376f6cb&scoped=true&"
import script from "./PlgBrand.vue?vue&type=script&lang=js&"
export * from "./PlgBrand.vue?vue&type=script&lang=js&"
import style0 from "./PlgBrand.vue?vue&type=style&index=0&id=0376f6cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0376f6cb",
  null
  
)

export default component.exports